import { action, Action, thunk, Thunk } from 'easy-peasy'

import { Challenge } from '@chessclub/proto-ts/index.reward_service'
import { MessageType } from '@chessclub/proto-ts/index.websocket_gateway'
import { StoreModel } from '../../store/store'
import { claimChallenge, getRewards } from './API'
import { RewardsResponse } from './types'

// Define the WebSocket model interface
export interface RewardsServiceModel {
    // State
    challenges?: RewardsResponse['challenges']
    rewards?: RewardsResponse['rewards']
    isCompletedChallenges: boolean
    completedChallenge: Challenge | undefined

    // // Actions
    setChallenges: Action<RewardsServiceModel, RewardsResponse['challenges']>
    setRewards: Action<RewardsServiceModel, RewardsResponse['rewards']>
    setIsCompletedChallenges: Action<RewardsServiceModel, boolean>
    setCompletedChallenge: Action<RewardsServiceModel, Challenge | undefined>

    // // Thunks
    getRewards: Thunk<RewardsServiceModel, undefined, undefined, StoreModel>
    establishListener: Thunk<RewardsServiceModel, undefined, undefined, StoreModel>
    claimChallenge: Thunk<RewardsServiceModel, number, undefined, StoreModel>
}

// WebSocket model implementation
export const RewardsServiceModel: RewardsServiceModel = {
    // State
    challenges: undefined,
    rewards: undefined,
    isCompletedChallenges: false,
    completedChallenge: undefined,

    // Actions

    setChallenges: action((state, message) => {
        state.challenges = message
    }),

    setIsCompletedChallenges: action((state, isCompleted) => {
        state.isCompletedChallenges = isCompleted
    }),

    setRewards: action((state, message) => {
        state.rewards = message
    }),

    setCompletedChallenge: action((state, challenge) => {
        state.completedChallenge = challenge
    }),

    // Thunks

    getRewards: thunk(async (actions) => {
        const data = await getRewards()
        if (!data) return
        actions.setChallenges(data.challenges)
        actions.setRewards(data.rewards)

        actions.setIsCompletedChallenges(
            data.challenges.some((challenge) => challenge.threshold === challenge.progress),
        )
    }),

    claimChallenge: thunk(async (actions, challengeId, { getStoreState, getStoreActions }) => {
        const data = await claimChallenge(challengeId)
        actions.getRewards()
    }),

    establishListener: thunk((actions, _, { getStoreState, getStoreActions }) => {
        const { ws } = getStoreActions()
        const { isConnected } = getStoreState().ws
        if (isConnected) {
            ws.addListener({
                messageType: MessageType.CHALLENGE_COMPLETED,
                callback: (message) => {
                    const challenges = getStoreState().rewardsService.challenges || []
                    const updatedChallenges = challenges.map((challenge) => {
                        if (challenge.id === message.id) {
                            return { ...message, endDate: challenge.endDate }
                        }
                        return challenge
                    })

                    actions.setChallenges(updatedChallenges)
                    actions.setCompletedChallenge(message)
                },
            })
        }
    }),

    // shareLocation: thunk((actions, url, { getStoreState, getStoreActions }) => {
    //     const clientUUID = getStoreState().userData.userData?.id

    //     clientUUID &&
    //         getStoreActions().ws.sendMessage({
    //             messageType: MessageType.POPUP_ACTION,
    //             message: { clientId: { value: clientUUID }, url },
    //         })
    // }),
}

// WebsocketModel
